import * as React from "react";
import FalconHeader from "../../../../../components/navigation/FalconHeader";
import {BackButton} from "../../../../../components/navigation/BackButton";
import FalconFooter from "../../../../../components/navigation/FalconFooter";
import {getSessionStorage} from "../../../../../CommonFunctions";
import {FalconNavigatorHeader, resourcesHelper, CLAIM_TYPE_BREAKDOWN, CLAIM_TYPE_MOTOR} from "@falcon/services";
import {RouteComponentProps} from "react-router-dom";
import {Button} from "reactstrap";

interface IWindscreenOrBreakdownClaimPageParams {
    policyNumber: string;
}

interface IWindscreenOrBreakdownClaimPageProps extends RouteComponentProps<IWindscreenOrBreakdownClaimPageParams> {
    location: any;
}

export class WindscreenOrBreakdownClaimPage extends React.Component<IWindscreenOrBreakdownClaimPageProps> {

    constructor(props: IWindscreenOrBreakdownClaimPageProps) {
        super(props);
    }

    public render() {
        const claim: string = getSessionStorage("claim");
        let claimTitle;

        if(claim === CLAIM_TYPE_MOTOR){
            claimTitle = "Windscreen Claim Reporting";
        }else if(claim === CLAIM_TYPE_BREAKDOWN){
            claimTitle = "Breakdown claim Reporting";
        }else{
            claimTitle = "All other claims";
        }

        return (
            <React.Fragment>
                <FalconHeader/>
                    <div className="page-contents dashboard-page">
                        <FalconNavigatorHeader
                            back={`/dashboard/pickAnnualMotorClaimKind/${this.props.match.params.policyNumber}`}
                            title={claimTitle}
                        />
                        <div className="panel claim-page reset-margins">
                            <div className="dl-widget-video-panel">
                                <img className="claims-icon" src={`/${resourcesHelper.THEME}/img/make-a-claim.png`} alt="Make a claim icon"/>
                            </div>
                            <p className="mt-4 mb-4 font-weight-bold text-center claim-text">{claim === CLAIM_TYPE_MOTOR ?
                                "To report a windscreen or glass damage get in touch with our recommended windscreen providers. You can arrange an appointment on-line by using the buttons below. It's simple and quick!" :
                                "For any claims on your car(s) call our 24 hour helpline"}</p>
                            {claim === CLAIM_TYPE_MOTOR &&
                                <div className="windscreen-options">
                                    <div className="dl-widget-video-panel windscreen-icon grid-row-1">
                                        <img className="windscreen-icon" src="/img/national-windscreens-logo.png" alt="National Windscreens icon"/>
                                    </div>
                                    <Button className="my-2 w-100 grid-col-1" color="btn btn-primary btn-next-no-arrow" href="https://www.nationalwindscreens.co.uk/allianzcar">Book National Windscreens</Button>
                                    <p className="mt-4 mb-4 font-weight-bold text-center grid-col-1-2">Or call us on our 24 hour helpline and select option #1</p>
                                </div>
                            }
                            <div className="text-center mb-4">
                                <a href="tel:+44 8000 304 897" className="mb-4 no-underline font-weight-semi-bold icon-phone-before margin-top-10" id="claimsPagePhoneLink" aria-label="Phone number +44 8000 304 897">{ claim === CLAIM_TYPE_BREAKDOWN ? "0330 678 7112" : "0330 678 5557" }</a>
                                <p className="font-weight-bold mb-1 mt-3 margin-top-10">From abroad</p>
                                <a href="tel:+44 120 284 8509" className="mb-4 no-underline font-weight-semi-bold icon-phone-before margin-top-10" id="claimsPagePhoneLinkAbroad" aria-label="Phone number +44 120 284 8509">{ claim === CLAIM_TYPE_BREAKDOWN ? "(+44) 01202 295398" : "(+44) 0120 284 8509" }</a>
                            </div>
                            <p className="text-center margin-top-10">Lines open <span className="font-weight-bold">24 hours, 7 days a week.</span>{' '}
                                Calls will be recorded. For Text Phone, first dial 18001
                            </p>
                        </div>
                        <BackButton isTop={false} link={`/dashboard/pickAnnualMotorClaimKind/${this.props.match.params.policyNumber}`}/>
                    </div>
                <FalconFooter/>
            </React.Fragment>
        );
    }
}



// WEBPACK FOOTER //
// ./src/pages/dashboard/annual/motor/claims/WindscreenOrBreakdownClaimPage.tsx